import Checkbox from 'components/UI/Input/Checkbox';
import React from 'react';
import PropTypes from 'prop-types';

function EditableCheckbox({
    containerClassName,
    editing,
    inputProps,
    labelText,
    labelTextClassName,
    reverse,
})
{
    const label = (
        <div className="tw-flex tw-mr-1">
            <label className={labelTextClassName}>
                {labelText}
            </label>
        </div>
    );

    const check = (
        <div className="tw-flex">
            <Checkbox
                className={inputProps.className}
                containerClassName="tw-w-full"
                onChange={inputProps.onChange}
                error={inputProps.error}
                printErrors={inputProps.printErrors}
                value={inputProps.value}
                path={inputProps.path}
                styles={inputProps.styles}
                errorClassName={inputProps.errorClassName}
                text={inputProps.text}
                disabled={inputProps.disabled}
            />
        </div>
    );

    return (
        <div className={`tw-flex tw-flex-row ${containerClassName}`}>
            {!reverse && <>{label}{check}</>}
            {reverse && <>{check}<span className="tw-ml-2" />{label}</>}
        </div>
    );
}

EditableCheckbox.defaultProps = {
    containerClassName: '',
    inputProps: {},
    reverse: false,
    labelTextClassName: 'tw-font-bold tw-align-middle tw-mb-0 tw-mr-1 tw-text-sm',
};

EditableCheckbox.propTypes = {
    containerClassName: PropTypes.string,
    editing: PropTypes.bool.isRequired,
    inputProps: PropTypes.shape({
        onChange: PropTypes.func,
        error: PropTypes.node,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        printErrors: PropTypes.bool,
        value: PropTypes.any,
        path: PropTypes.string,
        styles: PropTypes.object,
        containerClassName: PropTypes.string,
        errorClassName: PropTypes.string,
        text: PropTypes.string,
    }),
    labelText: PropTypes.string.isRequired,
    reverse: PropTypes.bool,
    labelTextClassName: PropTypes.string,
};

export default EditableCheckbox;
